<template>
  <div>
    <com-dialog :visible.sync="visible" width="40%" :title="type === 'created' ? '新增' : '编辑'">
      <div>
        <div class="flex items-center">
          <div class="flex w-120px">场景:</div>
          <div>
            <el-radio v-model="form.location" label="USER">循电充电</el-radio>
            <el-radio v-model="form.location" label="PARTNER">循电合伙人</el-radio>
          </div>
        </div>
        <div class="flex items-center mt-30px">
          <div class="flex w-120px">分类名称:</div>
          <el-input v-model="form.name"></el-input>
        </div>
        <div class="flex items-center justify-end mt-15px">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { updatedQuestionTypeApi as update, addQuestionTypeApi as add } from '@/api/help-center'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      title: '新增',
      type: '',
      form: {}
    }
  },
  methods: {
    baseForm() {
      return {
        name: '',
        location: ''
      }
    },
    handleUpdate() {
      update(this.form).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },
    handleAdd() {
      add(this.form).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },
    open(opt) {
      const { type, row } = opt
      this.type = type
      if (type === 'edit') this.form = utils.deepCopy(row)
      if (type === 'created') this.form = this.baseForm()
      this.visible = true
    },
    close() {
      this.visible = false
      setTimeout(() => {
        this.form = {}
      }, 200)
    },
    confirm() {
      if (this.type === 'edit') {
        this.handleUpdate()
        return
      }
      this.handleAdd()
    }
  }
}
</script>

<style lang="scss" scoped></style>
